import React, { Component } from 'react';
import './index.css';
import { getWeatherData } from '../../services/weather';

export default class Weather extends Component {
  state = {
    currentWeather: 'Loading...',
    currentTemperature: 0,
    currentUnit: 'C',
    availableUnit: 'F'
  };

  componentDidMount() {
    this.fetchWeather(this.state.currentUnit);
  }

  fetchWeather(units) {
    const coords = {
      lat: 47.179397,
      lon: 27.617117
    };

    getWeatherData(units, coords)
    .then(weatherData => {
      this.setState({
        currentTemperature: weatherData.body.main.temp,
        currentUnit: units,
        availableUnit: units === 'C' ? 'F' : 'C'
      });
    }, (error) => {
      // Could not get weather data.
      console.log('Error fetching weather data. ', error);
    });
  }

  render() {
    return (
      <div className="">
        <div className="">
          <span className="">{this.state.currentTemperature}&#176;{this.state.currentUnit}</span>
          <span className="u-c-pointer" onClick={this.fetchWeather.bind(this, this.state.availableUnit)}> / {this.state.availableUnit} Iași |</span>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/weather/index.js